import Calendar from '@apps/calendar/admin/components/calendar'
import Page from '@admin/components/page'

const mapPropsToPage = (props, context, resources) => ({
  title: 't(Calendar)',
  component: Calendar
})

export default Page(null, mapPropsToPage)
